var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7516 14.3604V16.3904C9.7516 18.1104 8.15158 19.5004 6.18158 19.5004C4.21158 19.5004 2.60156 18.1104 2.60156 16.3904V14.3604C2.60156 16.0804 4.20158 17.3004 6.18158 17.3004C8.15158 17.3004 9.7516 16.0704 9.7516 14.3604Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7501 11.61C9.7501 12.11 9.6101 12.57 9.3701 12.97C8.78006 13.94 7.57004 14.55 6.17004 14.55C4.77004 14.55 3.56003 13.93 2.97003 12.97C2.73003 12.57 2.59009 12.11 2.59009 11.61C2.59009 10.75 2.99007 9.97999 3.63007 9.41999C4.28007 8.84999 5.17003 8.50999 6.16003 8.50999C7.15003 8.50999 8.04006 8.85999 8.69006 9.41999C9.3501 9.96999 9.7501 10.75 9.7501 11.61Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7516 11.61V14.36C9.7516 16.08 8.15158 17.3 6.18158 17.3C4.21158 17.3 2.60156 16.07 2.60156 14.36V11.61C2.60156 9.89 4.20158 8.5 6.18158 8.5C7.17158 8.5 8.06161 8.85 8.71161 9.41C9.3516 9.97 9.7516 10.75 9.7516 11.61Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.4699V10.53C21 11.08 20.56 11.5299 20 11.5499H18.0399C16.9599 11.5499 15.97 10.7599 15.88 9.6799C15.82 9.0499 16.0599 8.4599 16.4799 8.0499C16.8499 7.6699 17.36 7.44995 17.92 7.44995H20C20.56 7.46995 21 7.9199 21 8.4699Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8V6C1 3.28 2.64 1.38 5.19 1.06C5.45 1.02 5.72 1 6 1H15C15.26 1 15.51 1.00999 15.75 1.04999C18.33 1.34999 20 3.26 20 6V7.45001H17.92C17.36 7.45001 16.85 7.67 16.48 8.05C16.06 8.46 15.82 9.05 15.88 9.68C15.97 10.76 16.96 11.55 18.04 11.55H20V13C20 16 18 18 15 18H12.5",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionBlue);
export default __webpack_public_path__ + "static/media/option-blue.62e97697c7182ad52ee96ff00047aa7c.svg";
export { ForwardRef as ReactComponent };